const ConnectingType = {
  PUBLIC_ROAD: "公道",
  PRIVATE_ROAD: "私道",
  UNKNOWN: "わからない",
} as const;

export type IConnectingType = typeof ConnectingType[keyof typeof ConnectingType];

export const connectingTypeOptions = Object.values(ConnectingType).map(value => ({ label: value, value }));
